TPS.Reports = {
    txtStartDate: null,
    txtEndDate: null,
    ddProgramType: null,
    ddProgram: null,
    defaultPrograms: null,

    init: function () {
        var _this = TPS.Reports;

        _this.txtStartDate = document.getElementById('txtStartDate');
        _this.txtEndDate = document.getElementById('txtEndDate');
        _this.ddProgramType = document.getElementById('dplProgramType');
        _this.ddProgram = document.getElementById('dplProgram');

        _this.formDefaultDropdownsOptions();
        _this.initDatepickers();
        _this.initSelects();

        var queryProgramType = TPS.Util.getUrlParameter('programType');

        if (queryProgramType && queryProgramType !== '' && queryProgramType !== '0') {
            _this.filterDropdown(queryProgramType, _this.ddProgram, _this.defaultPrograms, false, true);
        }

        $(_this.ddProgramType).on('change', function (e) {
            _this.filterDropdown($(_this.ddProgramType).val(), _this.ddProgram, _this.defaultPrograms);
        });

    },

    formDefaultDropdownsOptions: function () {
        var _this = TPS.Reports;

        _this.defaultPrograms = $(_this.ddProgram).children('option').clone();
    },

    initDatepickers: function () {
        var _this = TPS.Reports;
        var _currentCulture = $('#lng').val();

        TPS.Forms.setDatePickerRegion(_currentCulture);

        // override default jQuery datepicker behavior when 'today' is selected
        $.datepicker._gotoToday = function (id) {
            var date,
                target = $(id),
                inst = this._getInst(target[0]);

            if (this._get(inst, "gotoCurrent") && inst.currentDay) {
                inst.selectedDay = inst.currentDay;
                inst.drawMonth = inst.selectedMonth = inst.currentMonth;
                inst.drawYear = inst.selectedYear = inst.currentYear;
            } else {
                date = new Date();
                inst.selectedDay = date.getDate();
                inst.drawMonth = inst.selectedMonth = date.getMonth();
                inst.drawYear = inst.selectedYear = date.getFullYear();
                this._setDateDatepicker(target, date);
                this._selectDate(id, this._getDateDatepicker(target));
            }
            this._notifyChange(inst);
            this._adjustDate(target);
        };

        $(_this.txtStartDate).datepicker({ showButtonPanel: true });
        $(_this.txtEndDate).datepicker({ showButtonPanel: true });
    },

    initSelects: function () {
        var _this = TPS.Reports;

        $(_this.ddProgramType).select2({
            minimumResultsForSearch: Infinity
        });

        $(_this.ddProgram).select2({
            placeholder: window.reportsLocalization.selectPrograms,
        });

        $(_this.ddProgramType).css('visibility', 'visible');
        $(_this.ddProgram).css('visibility', 'visible');

    },

    filterDropdown: function (selectedType, dropdownElement, defaultOptions, keepOptionAll = false, isInitial = false) {
        var newOptions = $(defaultOptions);

        if (!isInitial) {
            newOptions.each(function () {
                this.selected = false;
            });
        }

        if (selectedType !== '0') {
            newOptions = $(defaultOptions).filter(keepOptionAll ? '[data-type="' + selectedType + '"],[data-type="0"]' : '[data-type="' + selectedType + '"]');
        }

        $(dropdownElement).empty().append(newOptions);
    }
}
